export default __webpack_public_path__ + "static/media/dbd_placeholder.9862584a.png";